import React, { FC, SVGProps } from 'react';

export const Lock: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8 12.875C8.46875 12.875 8.875 12.5 8.875 12V10C8.875 9.53125 8.46875 9.125 8 9.125C7.5 9.125 7.125 9.53125 7.125 10V12C7.125 12.5 7.5 12.875 8 12.875ZM15 7.5C15 6.6875 14.3125 6 13.5 6H12.5V4.5625C12.5 2.0625 10.5 0.03125 8 0C5.5 0 3.5 2.03125 3.5 4.5V6H2.5C1.65625 6 1 6.6875 1 7.5V14.5C1 15.3438 1.65625 16 2.5 16H13.5C14.3125 16 15 15.3438 15 14.5V7.5ZM5 6V4.5C5 2.875 6.34375 1.5 8 1.5C9.625 1.5 11 2.875 11 4.5V6H5ZM13.5 7.5V14.5H2.5V7.5H13.5Z"
        fill="#181919"
      />
    </svg>
  );
};
